(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('ParticipationIbqDeleteController',ParticipationIbqDeleteController);

    ParticipationIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Participation'];

    function ParticipationIbqDeleteController($uibModalInstance, entity, Participation) {
        var vm = this;

        vm.participation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Participation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
